import React, { useCallback, useState } from 'react';
import classnames from 'classnames';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import style from './help-menu-dropdown.module.less';
import SupportSection from './sections/support-section';
import SupportResourceSection from './sections/support-resources-section';
import HotkeysModal from '../../hotkeys/hotkeys-modal';
import ListHotkeysHotkey from '../../hotkeys/list-hotkeys';
import { HelpIcon } from '../icons/help-icon';
import sharedStyles from '../shared-classes.module.less';

const HelpMenuDropdown = () => {
  const [isHotkeysModalOpen, setIsHotkeysModalOpen] = useState(false);

  const openHotkeysModal = useCallback(() => {
    setIsHotkeysModalOpen(true);
  }, []);

  const closeHotkeysModal = useCallback(() => {
    setIsHotkeysModalOpen(false);
  }, []);

  return (
    <>
      <ListHotkeysHotkey handler={openHotkeysModal}>
        <DropdownMenu
          className={style['help-menu-dropdown']}
          dropdownMenuClassName={style['suppport-dropdown-menu']}
          menuPosition='bottom-right'
        >
          <DropdownMenuToggler
            className={classnames(sharedStyles['icon-wrapper'], style['help-menu-dropdown-toggler'])}
            dropdownTogglerContentClassName={style['help-menu-dropdown-toggler-content']}
            hideChevron
            tabIndex={-1}
            testId='help-menu-dropdown-button'
            theme='unstyled'
          >
            <HelpIcon />
          </DropdownMenuToggler>
          <SupportSection />
          <SupportResourceSection openHotkeysModal={openHotkeysModal} />
        </DropdownMenu>
      </ListHotkeysHotkey>
      {isHotkeysModalOpen ? <HotkeysModal onClose={closeHotkeysModal} /> : null}
    </>
  );
};

export default HelpMenuDropdown;
